<template>
    <div>
        <div class="bloque-general">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="tramite-instrucciones">
                            <p>Llena el siguiente formulario para comenzar el trámite.</p>
                        </div>
                        <p>Al enviar el formulario un representante te contactará por medio del correo o teléfono que proporciones para continuar con el proceso.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    props: {
        servicio: Object,
    },
}
</script>
